import React from "react";
import { NavLink } from "react-router-dom";
import Modal from "react-modal";
import { ReusableOnboardingButton } from "../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import SuccessMessagePopup from "./SuccessMessagePopup";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    position: "relative",
    padding: "0px",
  },
};

export const TermsandConditionPopup = ({
  onOpenModal,
  onCloseModal,
  open,
  afterOpenModal,
  handleChecked,
  termsConditionDisabled,
  successPopupClick,
  successPopupOpenModal,
  onCloseModalSuccess,
}) => {
  return (
    <div>
      <ReusableOnboardingButton
        buttonTitle="I am done button"
        buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
        buttonText="I am done"
        buttonType="button"
        onClick={onOpenModal}
      />
      <Modal
        isOpen={open}
        onAfterOpen={afterOpenModal}
        onRequestClose={onCloseModal}
        style={customStyles}
        className="terms-and-condition-main-section"
        contentLabel="Example Modal"
        id="modal-termsAndConditions-subscription"
        ariaHideApp={false}
      >
        <div>
          <div className="terms-and-conditions-vendor-popup-header">
            <h4>Terms and Conditions</h4>
          </div>
          <hr />
          <div className="terms-and-conditions-vendor-popup-bodyBox">
            <div className="terms-and-conditions-vendor-popup-bodyBox-inside">
              <p>
                Welcome to Amealio This site is provided as a service to our
                visitors and may be used for informational purposes only.
                Because the Terms and Conditions contain legal obligations,
                please read them carefully.
              </p>
              <h6>1. YOUR AGREEMENT </h6>
              <p>
                By using this Site, you agree to be bound by, and to comply
                with, these Terms and Conditions. If you do not agree to these
                Terms and Conditions, please do not use this site. PLEASE NOTE:
                We reserve the right, at our sole discretion, to change, modify
                or otherwise alter these Terms and Conditions at any time.
                Unless otherwise indicated, amendments will become effective
                immediately. Please review these Terms and Conditions
                periodically. Your continued use of the Site following the
                posting of changes and/or modifications will constitute your
                acceptance of the revised Terms and Conditions and the
                reasonableness of these standards for notice of changes. For
                your information, this page was last updated as of the date at
                the top of these terms and conditions.
              </p>
              <h6>2. PRIVACY</h6>
              <p>
                Please review our Privacy Policy, which also governs your visit
                to this Site, to understand our practices.
              </p>
            </div>
            <div className="terms-and-conditions-vendor-popup-bodyBox-insidetwo">
              <label className="terms-and-conditions-text">
                <input
                  type="checkbox"
                  name="checkboxAcceptTerms"
                  className="checkbox"
                  onClick={handleChecked}
                />
              </label>
              <p className="terms-and-conditions-text">
                I have read the{" "}
                <NavLink
                  to="/cuisinesetup"
                  className="terms-and-conditions-link"
                >
                  terms and conditions
                </NavLink>{" "}
                of the agreement.
              </p>
            </div>
            <div className="terms-and-conditions-vendor-popup-button">
              <ReusableOnboardingButton
                buttonTitle="Cancel Button"
                buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                buttonText="Cancel"
                buttonType="button"
                onClick={onCloseModal}
              />
              {termsConditionDisabled === true ? (
                <SuccessMessagePopup
                  onOpenModalSuccess={successPopupClick}
                  openSuccess={successPopupOpenModal}
                  onCloseModalSuccess={onCloseModalSuccess}
                />
              ) : (
                <ReusableOnboardingButton
                  buttonType="button"
                  buttonTitle="Submit Button"
                  buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                  buttonText="Submit"
                />
              )}
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};
